import EmployeeAcknowledgementList from '@/components/library/employeeAcknowledgements/EmployeeAcknowledgementList.vue';
import FederalFlsaSurveyList from '@/components/library/flsaSurveys/FederalFlsaSurveyList.vue';
import ApprovalsLibraryList from '@/components/library/approvals/ApprovalsLibraryList.vue';
import HrisJobProfiles from '@/components/jobProfiles/HrisJobProfiles.vue';
import DraftJobProfiles from '@/components/jobProfiles/DraftJobProfiles.vue';
import JobProfileTemplates from '@/components/jobProfiles/JobProfileTemplates.vue';
import JobProfilesLibrary from '@/views/JobProfilesLibrary.vue';
import JobProfileView from '@/views/JobProfileView.vue';
import CreateJobProfileView from '@/views/CreateJobProfileView.vue';
import FlsaFormCreateView from '@/views/FlsaFormCreateView.vue';
import FlsaFormSubmissionView from '@/views/FlsaFormSubmissionView.vue';
import ApprovalTemplateEditorView from '@/views/ApprovalTemplateEditorView.vue';
import { checkPermissionsOrRedirect } from '@/helpers/routeMiddleware';
import ApprovalActions from '@/views/ApprovalActions.vue';

export const jobProfiles = (authDataStore) => ([
  {
    path: '/job-profiles/create',
    name: 'create-job-profile',
    component: CreateJobProfileView,
    beforeEnter: checkPermissionsOrRedirect(authDataStore, ['createDraftProfile']),
    meta: { title: 'Create Job Profile', parentTitle: 'Job Profiles' },
  },

  {
    path: '/job-profiles/',
    name: 'job-profiles-library',
    component: JobProfilesLibrary,
    meta: { title: 'Job Profiles' },
    children: [
      {
        name: 'employee-acknowledgements',
        path: 'employee-acknowledgements',
        component: EmployeeAcknowledgementList,
        beforeEnter: checkPermissionsOrRedirect(authDataStore, ['listEmployeeJobProfileAcknowledgements']),
        meta: { title: 'Employee Acknowledgements', parentTitle: 'Job Profiles' },
      },
      {
        name: 'federal-flsa-dashboard',
        path: 'federal-flsa-dashboard',
        component: FederalFlsaSurveyList,
        beforeEnter: checkPermissionsOrRedirect(authDataStore, ['listFlsaSurveyReportProfiles']),
        meta: { title: 'Federal FLSA Dashboard', parentTitle: 'Job Profiles' },
      },
      {
        name: 'hris-job-profiles',
        path: 'hris-job-profiles',
        component: HrisJobProfiles,
        beforeEnter: checkPermissionsOrRedirect(authDataStore, ['listJobProfileLibraryDocuments']),
        meta: { title: 'Workday Job Profiles', parentTitle: 'Job Profiles' },
      },
      {
        name: 'draft-job-profiles',
        path: 'draft-job-profiles',
        component: DraftJobProfiles,
        beforeEnter: checkPermissionsOrRedirect(authDataStore, ['listDraftProfileDocuments']),
        meta: { title: 'Draft Job Profiles', parentTitle: 'Job Profiles' },
      },
      {
        name: 'job-profile-templates',
        path: 'job-profile-templates',
        component: JobProfileTemplates,
        beforeEnter: checkPermissionsOrRedirect(authDataStore, ['listJobProfileTemplates']),
        meta: { title: 'Job Profile Templates', parentTitle: 'Job Profiles' },
      },
      {
        name: 'approvals-library',
        path: 'approvals',
        component: ApprovalsLibraryList,
        beforeEnter: checkPermissionsOrRedirect(authDataStore, ['viewApprovalsDashboard']),
        meta: { title: 'Approvals Dashboard', parentTitle: 'Job Profiles' },
      },
    ],
  },

  {
    path: '/job-profiles/approval/:id',
    name: 'approval-actions',
    component: ApprovalActions,
    props: true,
    meta: { title: 'Approval', parentTitle: 'Job Profiles' },
    beforeEnter: checkPermissionsOrRedirect(authDataStore, ['editJobApprovalFlow']),
  },

  {
    path: '/job-profile/:id',
    name: 'job-profile-view',
    props: true,
    meta: {
      title: ({ title } = {}) => ((typeof title === 'string')
        ? title
        : ''),
      parentTitle: 'Job Profiles',
    },
    component: JobProfileView,
    beforeEnter: checkPermissionsOrRedirect(authDataStore, ['initDraftProfileEditor']),
  },

  {
    path: '/job-profile-hris/:id',
    name: 'job-profile-hris-view',
    props: ({ params }) => ({ isHris: true, id: params.id }),
    meta: {
      title: ({ title } = {}) => ((typeof title === 'string')
        ? title
        : ''),
      parentTitle: 'Job Profiles',
    },
    component: JobProfileView,
    beforeEnter: checkPermissionsOrRedirect(authDataStore, ['initHrisProfileEditor']),
  },

  {
    path: '/flsa-form/:submissionUlid',
    name: 'flsa-form-view',
    props: true,
    meta: { title: 'FLSA Form', parentTitle: 'Job Profiles' },
    component: FlsaFormSubmissionView,
    beforeEnter: checkPermissionsOrRedirect(authDataStore, ['viewFlsaSubmission']),
  },

  {
    path: '/flsa-form',
    name: 'flsa-form-create',
    meta: { title: 'FLSA Form', parentTitle: 'Job Profiles' },
    component: FlsaFormCreateView,
    beforeEnter: checkPermissionsOrRedirect(authDataStore, ['createFlsaSubmission']),
  },

  {
    path: '/approval-template-editor',
    name: 'approval-template-editor',
    component: ApprovalTemplateEditorView,
    meta: { title: 'Template Editor' },
    beforeEnter: checkPermissionsOrRedirect(authDataStore, ['listApprovalTemplates']),
  },
]);
